import React from 'react';

/**
 * Composite slap preview with predicted segment bboxes (debug / segment-only mode).
 * bbox format: [left, top, right, bottom] in image pixel coordinates.
 */
export default function SlapCompositePreview({ imageUrl, imageSize, segments, onClick }) {
  if (!imageUrl) return null;

  const width = imageSize?.width || 1;
  const height = imageSize?.height || 1;

  return (
    <button
      type="button"
      className="relative inline-block max-w-full"
      onClick={onClick}
    >
      <img
        src={imageUrl}
        alt="Slap composite"
        className="max-h-56 w-full object-contain rounded border bg-gray-50"
        onLoad={(e) => {
          if (!imageSize && e.currentTarget.naturalWidth) {
            // parent may capture natural size via onImageLoad callback elsewhere
          }
        }}
      />
      <svg
        className="absolute inset-0 w-full h-full pointer-events-none"
        viewBox={`0 0 ${width} ${height}`}
        preserveAspectRatio="xMidYMid meet"
      >
        {(segments || []).map((seg) => {
          const bbox = seg.bbox || [0, 0, 0, 0];
          const [x1, y1, x2, y2] = bbox;
          const w = Math.max(0, x2 - x1);
          const h = Math.max(0, y2 - y1);
          return (
            <g key={`${seg.bioSubType}-${seg.index}`}>
              <rect
                x={x1}
                y={y1}
                width={w}
                height={h}
                fill="none"
                stroke="#16a34a"
                strokeWidth={Math.max(2, width / 200)}
              />
              <text
                x={x1 + 4}
                y={Math.max(14, y1 + 14)}
                fill="#16a34a"
                fontSize={Math.max(10, width / 80)}
                fontWeight="600"
              >
                {seg.bioSubType?.replace(/_/g, ' ')}
              </text>
            </g>
          );
        })}
      </svg>
    </button>
  );
}
